import { useContext } from 'react';

import { ButtonGroupContext } from './ButtonGroupContext';

export const useButtonGroupContext = () => {
  const ctx = useContext(ButtonGroupContext);

  const { value, onClick, activeButton } = ctx || {};

  return {
    value,
    onClick,
    activeButton,
  };
};
